export const API_BASE_URL = process.env.REACT_APP_BIRDMAP_API_BASE_URL || 'http://localhost:8081';
export const ALPHA_STATUS_ENDPOINT = '/api/alpha/status';
export const ECOREGION_ENRICHMENT_ENDPOINT = '/api/ecoregions/enrich';
export const REGION_ENRICHMENT_ENDPOINT = '/api/regions/enrich';
export const HOTSPOT_HABITAT_FEEDBACK_ENDPOINT = '/api/hotspots/habitat-feedback';
export const HOTSPOT_HABITAT_FEEDBACK_SUMMARY_ENDPOINT = '/api/hotspots/habitat-feedback-summary';
export const HOTSPOT_HABITAT_OVERRIDE_SUMMARY_ENDPOINT = '/api/hotspots/habitat-overrides-summary';
export const HOTSPOT_DETAIL_ENDPOINT = '/api/hotspots';
